import type { AuthUser } from './authHelper'

const KEY = 'familienkost_invoices_user'

export function saveSessionUser(user: AuthUser) {
    sessionStorage.setItem(KEY, JSON.stringify(user))
}

export function readSessionUser(): AuthUser | null {
    const raw = sessionStorage.getItem(KEY)
    if (!raw) return null
    try {
        return JSON.parse(raw) as AuthUser
    } catch {
        return null
    }
}

export function clearSessionUser() {
    sessionStorage.removeItem(KEY)
}